'use strict';
import $ from 'jquery';

export default class HomeHero {
    static init() {
        $('section.hero--home-new').each((index, el) => {
            new HomeHero($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.hero--home-new-carousel').on('init', (e, slick) => {
            this.el.find('.hero--home-new-carousel-slide').matchHeight();
        });
        this.el.find('.hero--home-new-carousel').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: this.el.find('.hero--home-new-carousel').data('speed'),
            dots: true
        });
    }
}